import { Injectable } from '@angular/core';
import { CompositionItem } from '../models/composition-item.model';
import { ModelElement } from '../models/model-element.model';
import { ConnectionSide } from '../enums/connection-side.enum';
import { hasConnector } from '../utils/connector.utils';

@Injectable({ providedIn: 'root' })
export class ComposerEngineService {

  getRequiredSide(
    composition: CompositionItem[],
    activeSide: ConnectionSide | null
  ): ConnectionSide | null {
    if (!composition.length) return null;
    if (activeSide === ConnectionSide.Right) return ConnectionSide.Left;
    if (activeSide === ConnectionSide.Left) return ConnectionSide.Right;
    return null;
  }

  canSelect(
    el: ModelElement,
    composition: CompositionItem[],
    activeSide: ConnectionSide | null
  ): boolean {
    const required = this.getRequiredSide(composition, activeSide);
    if (!required) return true;
    return hasConnector(el.type, required);
  }

  add(
    el: ModelElement,
    composition: CompositionItem[],
    side: ConnectionSide
  ): CompositionItem[] {
    const item: CompositionItem = {
      uid: crypto.randomUUID(),
      element: el
    };
    if (!composition.length) return [item];
    if (side === ConnectionSide.Left) return [item, ...composition];
    return [...composition, item];
  }
}
